
import React, { createContext } from 'react';
import { AuthContextType } from './types';

// Create the auth context with undefined as default value
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
